import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" aria-label="Footer">
      <div className="footer-container">
        <div className="footer-legal">
          <nav className="footer-links" aria-label="Legal links">
            <Link to="/terms-and-conditions" className="footer-link">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
          </nav>
        </div>
        <div className="footer-copy">© {year} Jody</div>
      </div>
    </footer>
  );
};

export default Footer;


